const fontTheme = {
  fontConfig: {
    PublicSans: {
      100: {
        normal: 'PublicSans-Regular',
        italic: 'PublicSans-Italic',
      },
      200: {
        normal: 'PublicSans-Regular',
        italic: 'PublicSans-Italic',
      },
      300: {
        normal: 'PublicSans-Regular',
        italic: 'PublicSans-Italic',
      },
      400: {
        normal: 'PublicSans-Regular',
        italic: 'PublicSans-Italic',
      },
      500: {
        normal: 'PublicSans-Regular',
        italic: 'PublicSans-Italic',
      },
      600: {
        normal: 'PublicSans-SemiBold',
        italic: 'PublicSans-SemiBoldItalic',
      },
      700: {
        normal: 'PublicSans-Bold',
        italic: 'PublicSans-BoldItalic',
      },
    },
    SourceSerifPro: {
      100: {
        normal: 'SourceSerifPro-Regular',
        italic: 'SourceSerifPro-Italic',
      },
      200: {
        normal: 'SourceSerifPro-Regular',
        italic: 'SourceSerifPro-Italic',
      },
      300: {
        normal: 'SourceSerifPro-Regular',
        italic: 'SourceSerifPro-Italic',
      },
      400: {
        normal: 'SourceSerifPro-Regular',
        italic: 'SourceSerifPro-Italic',
      },
      500: {
        normal: 'SourceSerifPro-Regular',
        italic: 'SourceSerifPro-Italic',
      },
      600: {
        normal: 'SourceSerifPro-SemiBold',
        italic: 'SourceSerifPro-SemiBoldItalic',
      },
      700: {
        normal: 'SourceSerifPro-Bold',
        italic: 'SourceSerifPro-BoldItalic',
      },
    },
  },
  fonts: {
    'sans-serif': 'PublicSans',
    'serif': 'SourceSerifPro',
    'header': 'SourceSerifPro',
    'body': 'PublicSans',
  },
  lineHeights: {
    '2xs': '20px',
    'xs': '20px',
    'sm': '22px',
    'md': '24px',
    'lg': '28px',
    'xl': '32px',
    '2xl': '40px',
    '3xl': '48px',
    '4xl': '56px',
    '5xl': '72px',
    '6xl': '104px',
    '7xl': '104px',
    '8xl': '104px',
    '9xl': '104px',
  },
  fontSizes: {
    '2xs': 12,
    'xs': 12,
    'sm': 14,
    'md': 16,
    'lg': 20,
    'xl': 26,
    '2xl': 32,
    '3xl': 40,
    '4xl': 48,
    '5xl': 64,
    '6xl': 96,
    '7xl': 96,
    '8xl': 96,
    '9xl': 96,
  },
};

export default fontTheme;
